import React from 'react';
import MicroModal from 'react-micro-modal';

const InfoWarningModal = (): JSX.Element => {
    return (
        <MicroModal
            overrides={{
                Root: {
                    className: 'modal modal--warning modal--auto-height',
                },
                Overlay: {
                    className: 'modal__overlay',
                },
                Dialog: {
                    className: 'modal__container modal__container--otz modal__container--otz-small',
                },
            }}
            openInitially={true}
        >
            {(close) => (
                <>
                    <div className="modal__content">
                        <div className="modal__closer" onClick={close}>
                            <img src="/img/layout/nav-closer.svg" alt="Zavřít" />
                        </div>
                        <div className="modal__inner">
                            <div className="modal__body">
                                <div className="modal-warning">
                                    <div className="modal-warning__content">
                                        <div className="modal-warning__header modal-warning__header--wider">
                                            <div className="text-content ta-c">
                                                <h3>
                                                    <span className="modal__pre-title">Upozornění</span>
                                                    <strong>
                                                        Domy s velikostí nad 350 m<sup>2</sup> řešíme individuálně
                                                    </strong>
                                                </h3>
                                            </div>
                                        </div>
                                        <div className="modal-warning__inner modal-warning__inner--narrow ta-c text-content text-content--md">
                                            <p className="c-gray">
                                                Rádi Vám pomůžeme skrze zákaznickou sekci nebo na naší infolince. 🙂
                                            </p>
                                        </div>
                                        <div className="modal-warning__footer">
                                            <a href="/dashboard" className="btn-solid btn-solid--black">
                                                Přejít do zákaznické sekce
                                            </a>
                                            <a
                                                href="tel:+420602702417"
                                                className="btn-solid btn-solid--green-clear-day-darker c-green-green-caribbean"
                                                id="house-area-warning-modal-submit"
                                            >
                                                <img className="m-r-15" src="/img/icon/phone-green.svg" alt="icon" />
                                                <span>602 702 417</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </MicroModal>
    );
};

export default InfoWarningModal;
